import { request } from '../request';

const ActionTestApi = {
  /**
   * 获取问卷内容
   */
  getQuestionnaireAndAnswer(params: GetActionTestQuestionnaireParams) {
    return request<GetActionTestQuestionnaireResponse>({
      path: '/pad/action/test/v1/getQuestionnaireAndAnswer',
      query: params,
    });
  },
  /**
   * 保存动作测试数据
   */
  saveActionTest(params: SaveActionTestParams) {
    return request<never>({
      path: '/pad/action/test/v1/save/result',
      method: 'POST',
      data: params,
    });
  },
  /**
   * 保存动作复测数据
   */
  saveActionRetest(params: SaveActionReTestParams) {
    return request<never>({
      path: '/pad/action/test/v1/save/retest/result/without/step',
      method: 'POST',
      data: params,
    });
  },
  /**
   * 保存补充动作测试数据
   */
  replenishActionRetest(params: ReplenishActionRetestParams) {
    return request<never>({
      path: '/pad/action/test/v1/save/replenish/result',
      method: 'POST',
      data: params,
    });
  },
  /**
   * 获取详情页动作测试数据
   */
  getComparisonOfActionTest(serviceOrderId: string) {
    return request<GetActionTestQuestionnaireResponse>({
      path: '/pad/action/test/v1/getComparison',
      query: { serviceOrderId },
    });
  },

  /**
   * 获取疼痛等级数据 - 磁振波服务记录中
   */
  getPainLevel(params: GetPainLevelParams) {
    return request<GetPainLevelResponse>({
      path: '/pad/service/order/v1/pain',
      method: 'GET',
      query: params,
    });
  },
  // /**
  //  * 保存疼痛等级数据 - 磁振波
  //  */
  // savePainLevel(params: SavePainLevelParams) {
  //   return request<never>({
  //     path: '/pad/service/order/v1/pain',
  //     method: 'POST',
  //     data: params,
  //   });
  // },
  /**
   * 保存动作测试数据&&疼痛程度 - 磁振波
   */
  saveActionTestAndPain(params: SaveActionTestAndPainParams) {
    return request<never>({
      path: '/pad/service/order/v1/action/test/save',
      method: 'POST',
      data: params,
    });
  },
};

export default ActionTestApi;
